import { isEmpty } from 'lodash';

const ChromeExtensionService = () => {
    const sendInvitation = async ({
        profileUrl,
        message,
        authToken,
        positionId,
        talentId,
    }) => new Promise((resolve, reject) => {
        try {
            chrome?.runtime?.sendMessage(window.ChromeExtensionId, {
                type: 'SendCandidateInviteMessage',
                profileUrl,
                message,
                authToken,
                positionId,
                talentId,
            }, (data) => {
                if (!data?.error) {
                    resolve(data);
                } else {
                    reject(data?.error || 'Unknown Linkedin error during sending invite');
                }
            });
        } catch (err) {
            reject(err);
        }
    });

    const sendMessage = async ({
        authToken,
        profileUrl,
        message,
        positionId,
        talentId,
    }) => new Promise((resolve, reject) => {
        try {
            chrome?.runtime?.sendMessage(window.ChromeExtensionId, {
                type: 'SendMessage',
                authToken,
                profileUrl,
                message,
                positionId,
                talentId,
            }, (data) => {
                if (!data?.error) {
                    resolve(data);
                } else {
                    reject(data?.error || 'Unknown Linkedin error during sending message');
                }
            });
        } catch (err) {
            reject(err);
        }
    });

    const getLinkedinInternalIdByPublicUrl = async ({ profileUrl }) => new Promise((resolve, reject) => {
        try {
            chrome?.runtime?.sendMessage(window.ChromeExtensionId, { type: 'GetLinkedinInternalIdByPublicUrl', profileUrl }, (data) => {
                if (!data?.error) {
                    resolve(data);
                } else {
                    reject(data?.error || 'Unknown Linkedin error during getting internal id');
                }
            });
        } catch (err) {
            reject(err);
        }
    });

    const getLinkedinCandidateConnectStatus = async ({ profileUrl }) => new Promise((resolve, reject) => {
        try {
            chrome?.runtime?.sendMessage(window.ChromeExtensionId, { type: 'GetLinkedinCandidateConnectStatus', profileUrl }, (data) => {
                if (!data?.error) {
                    resolve(data);
                } else {
                    reject(data?.error || 'Unknown Linkedin error during getting connection status');
                }
            });
        } catch (err) {
            reject(err);
        }
    });

    const getLinkedinConnections = async () => new Promise((resolve, reject) => {
        try {
            chrome?.runtime?.sendMessage(window.ChromeExtensionId, { type: 'GetLinkedinConnections' }, (data) => {
                if (!data?.error) {
                    resolve(data);
                } else {
                    reject(data?.error || 'Unknown Linkedin error during getting connections');
                }
            });
        } catch (err) {
            reject(err);
        }
    });

    const getSentInvitations = async () => new Promise((resolve, reject) => {
        try {
            chrome?.runtime?.sendMessage(window.ChromeExtensionId, { type: 'GetSentInvitations' }, (data) => {
                if (!data?.error) {
                    resolve(data);
                } else {
                    reject(data?.error || 'Unknown Linkedin error during getting sent invitations');
                }
            });
        } catch (err) {
            reject(err);
        }
    });

    const getReceivedInvitations = async () => new Promise((resolve, reject) => {
        try {
            chrome?.runtime?.sendMessage(window.ChromeExtensionId, { type: 'GetReceivedInvitations' }, (data) => {
                if (!data?.error) {
                    resolve(data);
                } else {
                    reject(data?.error || 'Unknown Linkedin error during received invitations');
                }
            });
        } catch (err) {
            reject(err);
        }
    });

    const syncUserLinkedinConnections = async ({ userId, authToken }) => new Promise((resolve, reject) => {
        try {
            chrome?.runtime?.sendMessage(window.ChromeExtensionId, { type: 'SyncUserLinkedinConnections', userId, authToken }, (data) => {
                if (!data?.error) {
                    resolve(data);
                } else {
                    reject(data?.error || 'Unknown Linkedin error during syncing connections');
                }
            });
        } catch (err) {
            reject(err);
        }
    });

    const getCurrentUserId = async () => new Promise((resolve, reject) => {
        try {
            chrome?.runtime?.sendMessage(window.ChromeExtensionId, { type: 'GetCurrentUserId' }, (data) => {
                if (!data?.error) {
                    resolve(data);
                } else {
                    reject(data?.error || 'Unknown Linkedin error during getting current user id');
                }
            });
        } catch (err) {
            reject(err);
        }
    });

    const isChromeExtensionInstalled = () => !isEmpty(window.ChromeExtensionId);

    return {
        isChromeExtensionInstalled,
        getCurrentUserId,
        sendMessage,
        sendInvitation,
        getLinkedinInternalIdByPublicUrl,
        getLinkedinCandidateConnectStatus,
        getLinkedinConnections,
        getSentInvitations,
        getReceivedInvitations,
        syncUserLinkedinConnections,
    };
};

export default ChromeExtensionService();
